import {useQuery, gql} from "@apollo/client";
var  SEARCH_ALL = gql`query SearchAll($searchText: String = " ") {
    searchAll( parameters: $searchText) {
      content_ContentItem_DisplayText
      content_ContentItem_ContentItemId
      content_ContentItem_ContentType
      aliasPart
    }
  }`

export const useSearchAll = (searchText) => {
    const {error, data, loading} = useQuery(SEARCH_ALL, {
      variables: { searchText: searchText }
    });
    return {
      error,
      data,
      loading
    }
  }